export interface IDocType {
    keyid: number;
    text: string;
}

export interface IDocuments {
    id: number;
    datStr: string;
    dat?: Date;
    text: string;
    fileName: string;
}

export interface IFileList {
    control_name: string;
    file?: FileList;
    filename?: string;
    fileBK?: string; // файл на бэке
}

export enum EUploadStatus {
    LOADING,
    SUCCESS,
    ERROR,
}

export interface IAttachedFile {
    file?: File;
    name: string;
    ext: string;
    status: EUploadStatus;
    id: number | null; // Id from database
    link_id: number | null; // Visit id file attached to
    storage_path: string
}

export interface IFilelistFromDB {
    id: number;
    name: string;
    fileType: string;
    storage_path?: string
}
export interface IResponseFileAction {
  id: number;
  errCode: number;
  errText: string;
}
